import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiShield, FiAward, FiEye, FiUsers, FiGlobe, FiCheckCircle } from 'react-icons/fi';

interface BenefitItem {
  icon: React.ReactNode;
  titleKey: string;
  descriptionKey: string;
}

const benefits: BenefitItem[] = [
  {
    icon: <FiShield size={32} />,
    titleKey: 'whyAmpi.secureTransactions',
    descriptionKey: 'whyAmpi.secureTransactionsDesc'
  },
  {
    icon: <FiAward size={32} />,
    titleKey: 'whyAmpi.certifiedAdvisors',
    descriptionKey: 'whyAmpi.certifiedAdvisorsDesc'
  },
  {
    icon: <FiEye size={32} />,
    titleKey: 'whyAmpi.totalTransparency',
    descriptionKey: 'whyAmpi.totalTransparencyDesc'
  },
  {
    icon: <FiUsers size={32} />,
    titleKey: 'whyAmpi.professionalNetwork',
    descriptionKey: 'whyAmpi.professionalNetworkDesc'
  },
  {
    icon: <FiGlobe size={32} />,
    titleKey: 'whyAmpi.internationalReach',
    descriptionKey: 'whyAmpi.internationalReachDesc'
  },
  {
    icon: <FiCheckCircle size={32} />,
    titleKey: 'whyAmpi.ampiSupport',
    descriptionKey: 'whyAmpi.ampiSupportDesc'
  }
];

export default function WhyAMPI() {
  const { t } = useTranslation();

  return (
    <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <h2 className="fw-bold mb-3" style={{ color: '#0a2f27' }}>
              {t('whyAmpi.title')}
            </h2>
            <p className="text-muted fs-5">
              {t('whyAmpi.subtitle')}
            </p>
          </div>
        </div>

        <div className="row g-4">
          {benefits.map((benefit, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div
                className="card h-100 border-0 shadow-sm hover-lift"
                style={{
                  borderRadius: '12px',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
              >
                <div className="card-body p-4">
                  <div
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{
                      width: '64px',
                      height: '64px',
                      backgroundColor: 'rgba(10, 47, 39, 0.1)',
                      color: '#0a2f27'
                    }}
                  >
                    {benefit.icon}
                  </div>
                  <h5 className="fw-bold mb-2" style={{ color: '#0a2f27' }}>
                    {t(benefit.titleKey)}
                  </h5>
                  <p className="text-muted mb-0">
                    {t(benefit.descriptionKey)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .hover-lift:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.1) !important;
        }
      `}</style>
    </section>
  );
}
